import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

// Function to make a GET request with message handling
export const getData = async (endpoint, headers) => {
  try {
    const response = await axios.get(`${baseURL}/${endpoint}`, { headers });
    return {
      success: true,
      data: response.data,
      message: "Data fetched successfully",
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      success: false,
      data: null,
      message: "Error fetching data. Please try again later.",
    };
  }
};

// Function to make a POST request with message handling
export const postData = async (endpoint, data, headers) => {
  try {
    const response = await axios.post(`${baseURL}/${endpoint}`, data, {
      headers,
    });
    return {
      success: true,
      data: response.data,
      message: "Data posted successfully",
    };
  } catch (error) {

    let message = "Error posting data. Please try again later.";

    // Check if the error response contains a message
    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
    }

    return {
      success: false,
      data: null,
      message
    };
  }
};

// Function to make a PUT request with message handling
export const putData = async (endpoint, data, headers) => {
  try {
    const response = await axios.put(`${baseURL}/${endpoint}`, data, {
      headers,
    });
    return {
      success: true,
      data: response.data,
      message: "Data updated successfully",
    };
  } catch (error) {
    console.error("Error posting data:", error);
    return {
      success: false,
      data: null,
      message: "Error updating data. Please try again later.",
    };
  }
};

// Function to make a Delete request with message handling
export const deleteData = async (endpoint, data, headers) => {
  console.log(data, headers);
  try {
    const response = await axios.delete(`${baseURL}/${endpoint}`, {
      headers,
      data
    });
    return {
      success: true,
      data: response.data,
      message: "Data deleted successfully",
    };
  } catch (error) {
    console.error("Error posting data:", error);
    return {
      success: false,
      data: null,
      message: "Error deleting data. Please try again later.",
    };
  }
};
